// extracted by mini-css-extract-plugin
export default {"ReduxBlog":"YZkhWeFdMfP7YWdvGBIy"};